var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u(
        [
          _vm.isEmbedded
            ? {
                key: "card-header",
                fn: function () {
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "p-0",
                        attrs: { variant: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("back")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n      ← " +
                            _vm._s(_vm.$t("global.words.back")) +
                            "\n    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "bold" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("financial-tools.scenarioBuilder")) +
                          "\n    "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              }
            : null,
          {
            key: "card-footer",
            fn: function () {
              return [
                _c("mortgage-calculators-toolbar", {
                  attrs: { "show-preview": false, "show-calculate": false },
                  on: { "clear-selection": _vm.handleClearSelection },
                }),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm.isEmbedded
        ? _c(
            "fieldset",
            { staticClass: "mb-4", staticStyle: { border: "3px groove" } },
            [
              _c("legend", { staticClass: "bold ml-2 px-2" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("application-form.mortgage")) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-nowrap", attrs: { cols: "12" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("application-form.mortgage-type")) +
                              ":\n          "
                          ),
                          _vm._l(_vm.availableMortgageTypes, function (mt) {
                            return _c(
                              "span",
                              { key: mt.value, staticClass: "ml-3" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedMortgageType,
                                      expression: "selectedMortgageType",
                                    },
                                  ],
                                  attrs: {
                                    id: "mt-radio-" + mt.value,
                                    type: "radio",
                                    name: "mortgageTypeRadio",
                                    disabled: !mt.available,
                                  },
                                  domProps: {
                                    value: mt.value,
                                    checked: _vm._q(
                                      _vm.selectedMortgageType,
                                      mt.value
                                    ),
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        _vm.selectedMortgageType = mt.value
                                      },
                                      _vm.onMortgageTypeChange,
                                    ],
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "mr-2",
                                    class: { "text-muted": !mt.available },
                                    attrs: { for: "mt-radio-" + mt.value },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(mt.label) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-2" },
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$t("financial-tools.mortgage_amount")) +
                              ":"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatMoneyDisplay(
                                _vm.mortgageInfo.totalLoanAmount
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$t("financial-tools.monthlyPayment")) +
                              ":"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatMoneyDisplay(
                                _vm.mortgageInfo.monthlyPayment
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-2" },
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$t("financial-tools.interest_rate")) +
                              ":"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.mortgageInfo.interestRate) + " % "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("application-form.frequency-payment")
                            ) + ":"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatMoneyDisplay(
                                _vm.mortgageInfo.frequencyPayment
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-2" },
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$t("financial-tools.paymentFrequency")) +
                              ":"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.mortgageInfo.paymentFrequencyLabel) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-2" },
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("application-form.term")) + ":"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.mortgageInfo.termDisplay) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-2" },
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$t("application-form.amortization")) +
                              ":"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.mortgageInfo.amortizationDisplay) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-2" },
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("application-form.compounding-period")
                            ) + ":"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.mortgageInfo.compoundingPeriodLabel) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("financial-tools.scenarioBuilderText")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "mt-4", staticStyle: { border: "3px groove" } },
        [
          _c("legend", {}, [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-white bold",
                attrs: { id: "showScen", type: "button" },
                on: {
                  click: function ($event) {
                    _vm.showScen = !_vm.showScen
                  },
                },
              },
              [_vm._v("\n        -\n      ")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "ml-2 bold" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("financial-tools.scenario")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.showScen
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "align-items-center pt-2 ml-3",
                          attrs: { cols: "12", sm: "3" },
                        },
                        [
                          _vm._v(
                            "\n          1. " +
                              _vm._s(
                                _vm.$t("financial-tools.mortgageAmountEnter")
                              ) +
                              "\n          "
                          ),
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.bottom.html",
                                value: _vm.$t(
                                  "financial-tools.mortgage_amount_description"
                                ),
                                expression:
                                  "\n              $t('financial-tools.mortgage_amount_description')\n            ",
                                modifiers: { bottom: true, html: true },
                              },
                            ],
                            staticClass: "ml-2 registered-tooltip",
                            attrs: { name: "info-circle" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "m-0 p-0 mr-0 pb-1",
                          attrs: { cols: "12", sm: "2" },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              name: "mortgageAmount",
                              placeholder: "0",
                              "class-name": "fe-num-field dollar",
                              disabled: _vm.isEmbedded,
                              "allow-minus": false,
                              label: _vm
                                .$t("financial-tools.mortgage_amount")
                                .toString(),
                              "show-tooltip-message": true,
                              max: "100000000",
                              "max-length": 14,
                              "error-message":
                                _vm.erMsgs.errorMessageAmt.value.toString(),
                            },
                            model: {
                              value: _vm.editedms.totalLoanAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.editedms, "totalLoanAmount", $$v)
                              },
                              expression: "editedms.totalLoanAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "align-items-center pt-2 ml-3",
                          attrs: { cols: "12", sm: "3" },
                        },
                        [
                          _vm._v(
                            "\n          2. " +
                              _vm._s(
                                _vm.$t("financial-tools.selectCalcTools")
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "align-items-center pt-2",
                          attrs: { cols: "12", sm: "6" },
                        },
                        _vm._l(_vm.calcTypeOptions, function (option) {
                          return _c(
                            "span",
                            {
                              key: option.value,
                              staticClass: "fe-option col-xs-12",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editedms.calcTypeFlag,
                                    expression: "editedms.calcTypeFlag",
                                  },
                                ],
                                attrs: {
                                  id: option.value,
                                  type: "radio",
                                  name: "calcTypeOptions",
                                },
                                domProps: {
                                  value: option.value,
                                  checked: _vm._q(
                                    _vm.editedms.calcTypeFlag,
                                    option.value
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.editedms,
                                      "calcTypeFlag",
                                      option.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "mr-4",
                                  attrs: { for: option.value },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(option.label) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "align-items-center pt-2 ml-3",
                          attrs: { cols: "12", sm: "3" },
                        },
                        [
                          _vm._v(
                            "\n          3. " +
                              _vm._s(_vm.$t("financial-tools.enterInfoTools")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "align-items-center pt-2",
                          attrs: { cols: "12", sm: "2" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("financial-tools.interest_rate")) +
                              "\n          "
                          ),
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.bottom.html",
                                value: _vm.$t(
                                  "financial-tools.interest_rate_description"
                                ),
                                expression:
                                  "\n              $t('financial-tools.interest_rate_description')\n            ",
                                modifiers: { bottom: true, html: true },
                              },
                            ],
                            staticClass: "ml-2 registered-tooltip",
                            attrs: { name: "info-circle" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "m-0 p-0 mr-0 pb-1",
                          attrs: { cols: "12", sm: "2" },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              name: "netRate",
                              placeholder: "0",
                              "class-name": "fe-num-field decimal-input",
                              decimals: 3,
                              "allow-minus": false,
                              label: _vm
                                .$t("financial-tools.interest_rate")
                                .toString(),
                              max: "100",
                              "max-length": 6,
                              "show-tooltip-message": true,
                              "error-message":
                                _vm.erMsgs.errorMessageRate.value.toString(),
                            },
                            model: {
                              value: _vm.editedms.netRate,
                              callback: function ($$v) {
                                _vm.$set(_vm.editedms, "netRate", $$v)
                              },
                              expression: "editedms.netRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c("b-col", {
                        staticClass: "align-items-center pt-2 ml-3",
                        attrs: { cols: "12", sm: "3" },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "align-items-center pt-2",
                          attrs: { cols: "12", sm: "2" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("application-form.term")) +
                              "\n          "
                          ),
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.bottom.html",
                                value: _vm.$t(
                                  "financial-tools.termDescription"
                                ),
                                expression:
                                  "$t('financial-tools.termDescription')",
                                modifiers: { bottom: true, html: true },
                              },
                            ],
                            staticClass: "ml-2 registered-tooltip",
                            attrs: { name: "info-circle" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "m-0 p-0 mr-0 pb-1",
                          attrs: { cols: "12", sm: "2" },
                        },
                        [
                          _c("years-months-section", {
                            attrs: {
                              name: "actualPaymentTerm",
                              placeholder: "0",
                              "class-name": "fe-num-field",
                              "allow-minus": false,
                              label: _vm.$t("application-form.term").toString(),
                              "show-tooltip-message": false,
                              "hide-labels": false,
                            },
                            model: {
                              value: _vm.editedms.actualPaymentTerm,
                              callback: function ($$v) {
                                _vm.$set(_vm.editedms, "actualPaymentTerm", $$v)
                              },
                              expression: "editedms.actualPaymentTerm",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "m-0 p-0 mr-0 pb-1",
                          attrs: { cols: "12", sm: "1" },
                        },
                        [
                          _c("section-error", {
                            attrs: {
                              icon: false,
                              "error-message":
                                _vm.erMsgs.errorMessagePayTerm.value.toString(),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c("b-col", {
                        staticClass: "align-items-center pt-2 ml-3",
                        attrs: { cols: "12", sm: "3" },
                      }),
                      _vm._v(" "),
                      _vm.editedms.calcTypeFlag == "A"
                        ? [
                            _c(
                              "b-col",
                              {
                                staticClass: "pt-2",
                                attrs: { cols: "12", sm: "2" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("financial-tools.monthlyPayment")
                                    ) +
                                    "\n            "
                                ),
                                _c("icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.bottom.html",
                                      value: _vm.$t(
                                        "financial-tools.mortgagePaymentDescription"
                                      ),
                                      expression:
                                        "\n                $t('financial-tools.mortgagePaymentDescription')\n              ",
                                      modifiers: { bottom: true, html: true },
                                    },
                                  ],
                                  staticClass: "ml-2 registered-tooltip",
                                  attrs: { name: "info-circle" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "m-0 p-0 mr-0 pb-1",
                                attrs: { cols: "12", sm: "2" },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "pAndIPaymentAmountMonthly",
                                    placeholder: "0",
                                    "class-name": "fe-num-field dollar",
                                    "allow-minus": false,
                                    label: _vm
                                      .$t("financial-tools.monthlyPayment")
                                      .toString(),
                                    "show-tooltip-message": true,
                                    max: "100000000",
                                    "max-length": 14,
                                    "error-message":
                                      _vm.erMsgs.errorMessagePandI.value.toString(),
                                  },
                                  model: {
                                    value:
                                      _vm.editedms.pAndIPaymentAmountMonthly,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editedms,
                                        "pAndIPaymentAmountMonthly",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "editedms.pAndIPaymentAmountMonthly",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "b-col",
                              {
                                staticClass: "align-items-center pt-2",
                                attrs: { cols: "12", sm: "2" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("application-form.amortization")
                                    ) +
                                    "\n            "
                                ),
                                _c("icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.bottom.html",
                                      value: _vm.$t(
                                        "financial-tools.amortization_period_description"
                                      ),
                                      expression:
                                        "\n                $t('financial-tools.amortization_period_description')\n              ",
                                      modifiers: { bottom: true, html: true },
                                    },
                                  ],
                                  staticClass: "ml-2 registered-tooltip",
                                  attrs: { name: "info-circle" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "m-0 p-0 mr-0 pb-1",
                                attrs: { cols: "12", sm: "2" },
                              },
                              [
                                _c("years-months-section", {
                                  attrs: {
                                    name: "amortizationTerm",
                                    placeholder: "0",
                                    "class-name": "fe-num-field",
                                    "allow-minus": false,
                                    label: _vm
                                      .$t("application-form.amortization")
                                      .toString(),
                                    "show-tooltip-message": false,
                                    "hide-labels": false,
                                  },
                                  model: {
                                    value: _vm.editedms.amortizationTerm,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editedms,
                                        "amortizationTerm",
                                        $$v
                                      )
                                    },
                                    expression: "editedms.amortizationTerm",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "m-0 p-0 mr-0 pb-1",
                                attrs: { cols: "12", sm: "1" },
                              },
                              [
                                _c("section-error", {
                                  attrs: {
                                    icon: false,
                                    "error-message":
                                      _vm.erMsgs.errorMessageAmortPer.value.toString(),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3 mb-3" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "align-items-center pt-2 ml-3",
                          attrs: { cols: "12", sm: "2" },
                        },
                        [
                          _vm._v("\n          4.\n          "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-white bold ml-2",
                              attrs: {
                                id: "generateScenarios",
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.generateScenarios()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("financial-tools.calculate")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isEmbedded
                    ? _c("div", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("financial-tools.bottomText")) +
                            "\n      "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.bean.generatedMS[0].calcTypeFlag != ""
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("userSb-Scenario-Analyzer", {
                attrs: { bean: _vm.bean, "bean_prop.sync": "bean" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("userSb-Scenario-List", {
        attrs: { bean: _vm.bean, "bean_prop.sync": "bean" },
      }),
      _vm._v(" "),
      _vm.bean.generatedMS[0].calcTypeFlag != ""
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("userSb-Scenario-Comparison", {
                attrs: { bean: _vm.bean, "is-embedded": _vm.isEmbedded },
                on: { "set-scenario-as-mortgage": _vm.setScenarioAsMortgage },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4 ml-1" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("financial-tools.DHdisclaimer")) + "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }